import packages from "../services/packages";
import notification from "../services/notification";

export default {
    namespaced: true,
    state: {
        loading: false,
        packages: [],
        packageDetails: [],
        maxPage: 1,
        nextPage: 0,
        prevPage: 0,
        currentPage: 1,
        totalPerPage: 1,
        currentFirstItem: 1,
        currentLastItem: 1,
        initialPageCount: 0,
        editing: false,
        searching: false,
        errors: null,
        categories: [],
        searchableFields: [
            {
                value: "name",
                text: "Package Name"
            },
            {
                value: "price",
                text: "Price"
            },
            {
                value: "enabled",
                text: "Enabled"
            },
            {
                value: "disabled",
                text: "Disabled"
            }
        ]
    },
    mutations: {
        loading(state, value = true) {
            state.loading = value;
        },
        editing(state, value) {
            state.editing = value;
        },
        packages(state, packages) {
            state.packages = packages;
            state.loading = false;
            state.searching = false;
        },
        pagination(state, pagination) {
            console.log(pagination);
            state.totalPerPage = pagination.list.length;
            state.maxPage = pagination.max_page;
            state.prevPage = pagination.prev_page;
            state.nextPage = pagination.next_page;
            state.currentPage = state.prevPage + 1;
            state.currentFirstItem =
                state.initialPageCount * state.prevPage + 1;
            state.currentLastItem =
                state.currentFirstItem > 0
                    ? state.currentFirstItem + state.totalPerPage - 1
                    : 0;
        },
        errors(state, errors) {
            state.errors = errors;
            state.loading = false;
        },
        resetErrors(state) {
            state.errors = null;
        },
        editing(state, value) {
            state.editing = value;
        },
        setDetails(state, details) {
            state.packageDetails = details;
        },
        setInitialPageCount(state, list) {
            state.initialPageCount = list.length;
        },
        categories(state, categories) {
            state.categories = categories;
            state.loading = false;
        }
    },
    actions: {
        async getPackages({ commit }, param) {
            commit("loading");
            try {
                let response = await packages.getPackages(param);
                
                if (param.page == 1) {
                    await commit("setInitialPageCount", response.list);
                }

                await commit("packages", response.list);
                await commit("pagination", response);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async savePackage({ commit }, param) {
            commit("loading");
            try {
                let response = await packages.savePackage(param);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot create new package.");
                commit("errors", errors);
                console.log(errors);
                commit("loading", false);
            }
        },
        async updatePackage({ commit }, data) {
            commit("loading");
            try {
                let response = await packages.updatePackage(
                    data.uuid,
                    data.param
                );
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Oops, cannot update package.");
                commit("errors", errors);
                commit("loading", false);
            }
        },
        async resetErrors({ commit }) {
            commit("resetErrors");
        },
        async resetEditing({ commit }) {
            commit("editing", false);
        },
        async editing({ commit }) {
            commit("editing", true);
        },
        async viewPackage({ commit }, uuid) {
            commit("loading");
            try {
                let response = await packages.viewPackage(uuid);
                response.price = parseFloat(response.price.replace(/,/g, ''));
                commit("setDetails", response);
                commit("loading", false);
            } catch (errors) {
                notification.warning("Something went wrong");
                console.log(errors);
                commit("loading", false);
            }
        },
        async deletePackage({ commit }, uuid) {
            commit("loading");
            try {
                let response = await packages.deletePackage(uuid);
                notification.success(response.message);
                commit("loading", false);
            } catch (errors) {
                notification.warning(errors.errors.message);
                console.log(errors);
                commit("loading", false);
            }
        },
        async getCategories({ commit, state }) {
            commit("loading");
            try {
                let response = await packages.getCategories();
                response.list.unshift({'id': '', 'name': 'All Categories'});
                commit("categories", response.list);
                commit("loading", false);
            } catch (errors) {
                commit("errors", errors);
                commit("loading", false);
            }
        } 
    }
};
